module.exports = __webpack_public_path__ + "img/history_btn.85a97b4b.png";